module.exports = __webpack_public_path__ + "img/modify_group.92522f25.svg";